import React from 'react';
import { Outlet } from "react-router-dom";

const LandTypeRoot = () => {
  return (
    <div>
      <Outlet/>
    </div>
  );
};

export default LandTypeRoot;